<div class="shift-selector">
  <h6>{{title}}</h6>
  <h2>{{rangeString(selectedRange)}}</h2>
  <div #rangeSlider>
  </div>
</div>


